import React from 'react';
import PropTypes from 'prop-types';

const Landscape = ({ width, height }) => (
  <svg width={`${width}px`} height={`${height}px`} viewBox="-1 -1 112 66">
    <defs>
      <rect id="landscape-rect" width="110" height="61.875" rx="2" />
      <mask id="landscape-mask-1" x="-1" y="-1" width="112" height="63.875">
        <path fill="#fff" d="M-1-1h112v63.875H-1z" />
        <use xlinkHref="#landscape-rect" />
      </mask>
    </defs>
    <mask id="landscape-mask-2" fill="#fff">
      <use xlinkHref="#landscape-rect" />
    </mask>
    <g fill="none">
      <use fill="#FFF" fillRule="evenodd" xlinkHref="#landscape-rect" />
      <use
        stroke="#E8EBED"
        mask="url(#landscape-mask-1)"
        strokeWidth="2"
        xlinkHref="#landscape-rect"
      />
    </g>
    <circle
      fill="#E8EBED"
      fillRule="evenodd"
      mask="url(#landscape-mask-2)"
      cx="19"
      cy="21"
      r="9"
    />
    <path
      fill="#E8EBED"
      fillRule="evenodd"
      mask="url(#landscape-mask-2)"
      d="M10 63.935L41.912 33.61l11.92 15.998L88.34 9l9.977 16.746 10.996-4.633L126 64.683"
    />
  </svg>
);

Landscape.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
};

Landscape.defaultProps = {
  height: 67,
  width: 113,
};

export default Landscape;
